export default {
    h1: 'Únase a nosotros',
    h2: 'Conviértase en uno de los miembros de Airclass',
    p: 'Fundar una academia clasificada como el primero del mundo',
    flexible: 'Flexible',
    ful: 'Enriquecedor',
    high: 'salario',
    apply: 'solicite ahora',
    dialog: 'Por favor envía tu CV a este correo: ',
    copy: 'Copiar',
}